import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const ItemsHandoverDataRoadReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_ROAD_SUMMARY.id,
        label: 'SUMMARY',
      },
      {
        value: ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS.id,
        label: 'DETAILS',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default ItemsHandoverDataRoadReport;

ItemsHandoverDataRoadReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
